<script>
/**
 * ****************************************************************************
 * @description     :   Button component
 * @created at      :   2024/05/22
 * @created by      :   ANS903 – phuongdt@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
import _ from 'lodash-uuid';
/**
 * Import template
 */
import template from './template.html';
import helpers from '@/utils/helpers';

/**
 * Define content of button component
 */
var AnsButton = {
    template: template,
    props: {
        id: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: ''
        },
        buttonClass: {
            type: String,
            default: ''
        },
        iconClass: {
            type: String,
            default: ''
        },
        labelClass: {
            type: String,
            default: ''
        },
        isDisabled: Boolean,
        isCircle: {
            type: Boolean,
            default: false
        },
        isOutline: {
            type: Boolean,
            default: false
        },
        type: String,
        icon: String,
        isShowTooltip: {
            type: Boolean,
            default: false
        },
        isTab: {
            type: Boolean,
            default: false
        },
        tooltipPosition: {
            type: String,
            default: ''
        },
        tooltipTitle: {
            type: String,
            default: ''
        },
        style: {
            type: String,
            default: ''
        },
        onClick: Function
    },
    data() {
        return {
            modeDisabled: false
        };
    },
    created() {
        if (this.label != '検索') {
            if (!this.isTab) {
                this.modeDisabled = helpers.checkAuthorityMode(this.$route.name);
            }
        }
    },
    computed: {
        btnId() {
            if (!this.id) {
                return _.uuid();
            }
            return this.id;
        },
        disabled() {
            return this.isDisabled;
        },
        getClass() {
            let buttonClassObj = {};
            if (this.buttonClass && this.buttonClass.trim()) {
                this.buttonClass.split(' ').forEach((className) => {
                    if (className.trim()) {
                        buttonClassObj[className.trim()] = true;
                    }
                });
            }

            return {
                btn: true,
                'custom-button': true,
                'btn-outline-danger': this.isOutline && this.type === 'danger',
                'btn-outline-secondary': this.isOutline && this.type === 'secondary',
                'btn-outline-success': this.isOutline && this.type === 'success',
                'btn-outline-info': this.isOutline && this.type === 'info',
                'btn-outline-gray': this.isOutline && this.type === 'gray',
                'btn-danger': !this.isOutline && this.type === 'danger',
                'btn-secondary': !this.isOutline && this.type === 'secondary',
                'btn-success': !this.isOutline && this.type === 'success',
                'btn-info': !this.isOutline && this.type === 'info',
                'btn-gray': !this.isOutline && this.type === 'gray',
                'rounded-circle': this.isCircle,
                'p-0': this.isCircle,
                ...buttonClassObj
            };
        }
    },
    methods: {
        clickButton(e) {
            if (this.onClick) {
                this.onClick(e);
            }
        }
    }
};
export default AnsButton;
</script>
